import React, { useState } from 'react';
import { CriticalAlertsHeader } from '../components/ui/critical-alerts-header';
import { CriticalAlerts } from '../components/ui/critical-alerts';
import { CustomOverlaySidebar } from '../components/ui/custom-overlay-sidebar';
import { AI_FAILURE_TYPES, GATEWAY_FAILURE_TYPES } from '../constants/alertTypes';
import { useLogout } from '../hooks/useLogout';
import { useSidebar } from '../hooks/useSidebar';

const CriticalAlertsPage: React.FC = () => {
  const { sidebarOpen, closeSidebar, toggleSidebar } = useSidebar();
  const handleLogout = useLogout();
  const [sourceType, setSourceType] = useState<'all' | 'onpremise' | 'gateway'>('all');
  const [filters, setFilters] = useState({
    failureType: "all",
    severity: "all",
    status: "all",
    startTime: "",
    endTime: "",
  });

  const failureTypeOptions =
    sourceType === "gateway"
      ? GATEWAY_FAILURE_TYPES
      : sourceType === "onpremise"
        ? AI_FAILURE_TYPES
        : [...AI_FAILURE_TYPES, ...GATEWAY_FAILURE_TYPES];


  const handleFiltersChange = (newFilters: typeof filters) => {
    setFilters(newFilters);
  };

  const handleStatusFilterChange = (status: string) => {
    setFilters(prev => ({ ...prev, status }));
  };

  return (
    <div style={{ backgroundColor: "#0f0f0f", minHeight: "100vh" }}>
      {/* Custom Overlay Sidebar */}
      <CustomOverlaySidebar isOpen={sidebarOpen} onClose={closeSidebar} />

      {/* Main Content - Full Width */}
      <div className="w-full min-h-screen">
        <CriticalAlertsHeader
          onLogout={handleLogout}
          onSidebarToggle={toggleSidebar}
          onFiltersChange={handleFiltersChange}
          title="Critical Alerts"
          failureTypeOptions={failureTypeOptions}
          theme="critical"
          externalStatus={filters.status}
        />

        {/* Tabs for filtering by device type */}
        <div className="px-6 pt-4">
          <div className="flex gap-2 border-b" style={{ borderColor: 'rgba(255,255,255,0.08)' }}>
            {(['all', 'onpremise', 'gateway'] as const).map((type, i) => {
              const label = ['All Alerts', 'AI Systems', 'Gateways'][i];
              const isActive = sourceType === type;
              return (
                <button
                  key={type}
                  onClick={() => setSourceType(type)}
                  className="px-4 py-2 transition-colors relative"
                  style={{
                    fontWeight: isActive ? 500 : 400,
                    color: isActive ? '#F97316' : '#9CA3AF',
                  }}
                  onMouseEnter={e => { if (!isActive) (e.currentTarget as HTMLButtonElement).style.color = '#FB923C'; }}
                  onMouseLeave={e => { if (!isActive) (e.currentTarget as HTMLButtonElement).style.color = '#9CA3AF'; }}
                >
                  {label}
                  {isActive && (
                    <div className="absolute bottom-0 left-0 right-0 h-0.5" style={{ backgroundColor: '#F97316' }} />
                  )}
                </button>
              );
            })}
          </div>
        </div>

        <div className="p-6 pt-4">
          <CriticalAlerts
            filters={filters}
            sourceType={sourceType !== 'all' ? sourceType : undefined}
            onStatusFilterChange={handleStatusFilterChange}
          />
        </div>
      </div>
    </div>
  );
};

export default CriticalAlertsPage; 